
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ClassMetadata, FiscalContext, IAccountSaveCriteria, IActionCriteria, ICodeAndDescription } from "@tylertech/tyler-api-types";

/**
 * GLAccountService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class GLAccountService<T = unknown> {
    constructor(private readonly $apiService: ApiService) { }
    
    GetAccountAuthorizationRoles(filterString?: string): Promise<ICodeAndDescription[]> {
        return this.$apiService.sendAuth("IGLAccountService/GetAccountAuthorizationRoles", null, filterString);
    }
    GetAccountElements(): Promise<ICodeAndDescription[]> {
        return this.$apiService.sendAuth("IGLAccountService/GetAccountElements");
    }
    GetAccountMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IGLAccountService/GetAccountMetadata");
    }
    GetAccountNumber(pEntity: T): Promise<string> {
        return this.$apiService.sendAuth("IGLAccountService/GetAccountNumber", pEntity);
    }
    GetAcctTypeDescription(pEntity: T): Promise<string> {
        return this.$apiService.sendAuth("IGLAccountService/GetAcctTypeDescription", pEntity);
    }
    GetDefaultDescription(pEntity: T): Promise<string> {
        return this.$apiService.sendAuth("IGLAccountService/GetDefaultDescription", pEntity);
    }
    GetFiscals(): Promise<FiscalContext[]> {
        return this.$apiService.sendAuth("IGLAccountService/GetFiscals");
    }
    GetNewAccount(preliminaryInfo: any): Promise<T> {
        return this.$apiService.sendAuth("IGLAccountService/GetNewAccount", preliminaryInfo);
    }
    GetPreliminaryAccountMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IGLAccountService/GetPreliminaryAccountMetadata");
    }
    GetReportGroups(filterString?: string): Promise<ICodeAndDescription[]> {
        return this.$apiService.sendAuth("IGLAccountService/GetReportGroups", null, filterString);
    }
    PerformAction(pCriteria: IActionCriteria): Promise<any> {
        return this.$apiService.sendAuth("IGLAccountService/PerformAction", pCriteria);
    }
    Save(pCriteria: IAccountSaveCriteria<T>): Promise<T> {
        return this.$apiService.sendAuth("IGLAccountService/Save", pCriteria);
    }
}
